import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex mb-4 justify-between md:justify-around items-center" }
const _hoisted_2 = { class: "text-xl font-semibold text-main xs:w-auto xs:mb-0" }

import SearchBar from './SearchBar.vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'TableHeader',
  props: {
  title: String,
  placeholder: String,
  searchTerm: [Array, String],
},
  emits: ['update:search'],
  setup(__props, { emit: __emit }) {



const emit = __emit;

const handleSearch = (query: string) => {
  emit('update:search', query);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(__props.title), 1),
    _createVNode(SearchBar, {
      placeholder: __props.placeholder,
      searchTerm: __props.searchTerm,
      "onUpdate:search": handleSearch
    }, null, 8, ["placeholder", "searchTerm"])
  ]))
}
}

})